import Shipment from "../views/Shipment";
import Shipment_OLD from "../views/Shipment_OLD";
import Admin from "../views/admin";
import Permissions from "../views/host/Permissions";
import Roles from "../views/host/Roles";
import Metadata from "../views/Metadata";
import eMoverCustomer from "../views/eMoverCustomer";
import Address from "../components/Address";
import Shipments from "../views/Shipments";
import Loadboard from "../views/Loadboard";
import Customers from "../views/Customers";
import Agents from "../views/Agents";
import Brokers from "../views/Brokers";
import Employee from "../views/Employee";
import JobSchedule from "../views/JobSchedule";
import Company from "../views/Company";
import Tariffs from "../views/Tariffs";
import Tariff from "../views/Tariff";
import Settings from "../views/Settings";
import ManagementSettings from "../views/ManagementSettings";
import DocumentDesigner from "../views/DocumentDesigner";
import Test from "../views/test";
import ImportTable from "../views/ImportTable";
import Users from "../views/host/Users";
import Login from "../views/auth/Login";
import NotFound from "../views/auth/NotFound";
import Dashboard from "../views/Dashboard";
import ComponentTest from "../views/test";
import Dispatch from "../views/Dispatch";
import LocalDispatch from "../views/LocalDispatch";
import LDDispatch from "../views/LDDispatch";
import SITDispatch from "../views/SITDispatch";
import TripDispatch from "../views/TripDispatch";
import InternationalShipments from "../views/InternationalShipments";
import ForemanSchedule from "../views/ForemanSchedule";
import Storage from "../views/Storage";
import StorageDetail from "../views/StorageDetail";
import CustomerDetail from "../views/CustomerDetail";
import CustomerDocument from "../views/CustomerDocument";
import OnsiteEstimates from "../views/OnsiteEstimates";
import ReminderCalendar from "../views/ReminderCalendar";
import CustomerPortal from "../views/CustomerPortal";
import ReportWizard from "../views/ReportWizard";
import Reports from "../views/Reports";
import Report from "../views/Report";
import CreditCard from "../components/CreditCard";
import NewShipment from "../views/NewShipment";
import Portal from "../views/Portal";
import AIChat from "../components/AIChat";
import CreateAccount from "../components/CreateAccount";
import Portals from "../views/Portals";
import MoveraiPackages from "../views/MoveraiPackages";
import MyCustomers from "../views/MyCustomers";
import AvailablePackages from "../components/AvailablePackages";
import AuthorizeDropBox from "../views/auth/AuthorizeDropBox";
import AIChatSettings from "../views/AIChatSettings";
import StripeForm from "../components/StripeForm";
// import ObjectOnDemand from "../components/ObjectOnDemand";
import ComponentOnDemand from "../components/ComponentOnDemand";
import CustomerInventory from "../views/CustomerInventory";
import FormWrapper from "../views/FormWrapper";
import SettingsMenu from "../views/SettingsMenu";
import Payroll from "../views/Payroll";
import InternationalShipmentDispatch from "../views/InternationalShipmentDispatch";
import QuoteRedirect from "../views/QuoteRedirect";
import LeadAccess from "../views/LeadAccess";
export const routes = [
  {
    path: "/q/:pathMatch(.*)*",
    name: "QuoteRedirect",
    component: QuoteRedirect
  },
  {
    path: "/component-on-demand/:objectName/:objectId",
    name: "component-on-demand",
    component: ComponentOnDemand,
    props: true
  },
  {
    path: "/authorizedropbox",
    name: "AuthorizeDropBox",
    component: AuthorizeDropBox
  },
  {
    path: "/login/:id?",
    name: "Login",
    component: Login
  },
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard
  },

  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard
  },
  {
    path: "/shipment/:id",
    name: "Shipment",
    component: Shipment
  },
  {
    path: "/new-shipment",
    name: "New Shipment",
    component: Shipment
  },
  {
    path: "/shipment-old/:id",
    name: "  Shipment_OLD",
    component: Shipment_OLD
  },
  {
    path: "/new-shipment:id?",
    name: "New Shipment",
    component: NewShipment
  },
  {
    path: "/shipment/:id",
    name: "New shipment",
    component: Shipment
  },
  {
    path: "/customer-inventory/:id",
    name: "Customer Inventory",
    component: CustomerInventory
  },
  {
    path: "/customerportal/:id",
    name: "Customer Portal",
    component: CustomerPortal
  },
  {
    path: "/host",
    name: "Host",
    component: Admin
  },
  {
    path: "/chat_settings",
    name: "AI Chat Settings",
    component: AIChatSettings
  },
  {
    path: "/create-account/:id",
    name: "createaccount",
    component: CreateAccount
  },
  {
    path: "/form-wrapper/:id",
    name: "formwrapper",
    component: FormWrapper
  },
  {
    path: "/aichat/:id",
    name: "AIChat",
    component: AIChat
  },
  {
    path: "/guard/default_roles",
    name: "Guard",
    component: Roles
  },
  {
    path: "/metadata",
    name: "Metadata",
    component: Metadata
  },
  {
    path: "/portals",
    name: "Portals",
    component: Portals
  },
  {
    path: "/packages",
    name: "Packages",
    component: MoveraiPackages
  },
  {
    path: "/my-customers",
    name: "My Customers",
    component: MyCustomers
  },
  {
    path: "/moverai-packages",
    name: "AvailablePackages",
    component: AvailablePackages
  },
  {
    path: "/emovercustomer/:id",
    name: "emovercustomer",
    component: eMoverCustomer
  },
  {
    path: "/local-dispatch",
    name: "localdispatch",
    component: LocalDispatch
  },
  {
    path: "/ld-dispatch",
    name: "ldispatch",
    component: LDDispatch
  },
  {
    path: "/sit-dispatch",
    name: "sitdispatch",
    component: SITDispatch
  },
  {
    path: "/trip-dispatch",
    name: "tripdispatch",
    component: TripDispatch
  },
  {
    path: "/international-shipments/:id?",
    name: "internationalshipments",
    component: InternationalShipments
  },
  {
    path: "/international-shipment-dispatch",
    name: "InternationalShipmentDispatch",
    component: InternationalShipmentDispatch
  },
  {
    path: "/foreman-schedule",
    name: "foremanschedule",
    component: ForemanSchedule
  },
  {
    path: "/dispatch/:id",
    name: "dispatch",
    component: Dispatch
  },

  {
    path: "/reminder-calendar",
    name: "remindercalendar",
    component: ReminderCalendar
  },
  { path: "/employee/:type", component: Employee },
  {
    path: "/address",
    name: "Address test",
    component: Address
  },
  {
    path: "/shipments/:qry?",
    name: "Shipments",
    component: Shipments
  },

  {
    path: "/loadboard/:qry?",
    name: "Loadboard",
    component: Loadboard
  },
  {
    path: "/customers/:qry?",
    name: "customers",
    component: Customers
  },
  {
    path: "/agents",
    name: "agents",
    component: Agents
  },
  {
    path: "/payroll",
    name: "payroll",
    component: Payroll
  },
  {
    path: "/brokers",
    name: "brokers",
    component: Brokers
  },
  {
    path: "/onsite-estimates",
    name: "onsiteestimates",
    component: OnsiteEstimates
  },
  {
    path: "/job-schedule",
    name: "Schedule",
    component: JobSchedule
  },
  // {
  //   path: "/customer/:id",
  //   name: "customer",
  //   component: Customer,
  // },
  {
    path: "/company/:id",
    name: "company",
    component: Company
  },
  {
    path: "/tariffs",
    name: "tariffs",
    component: Tariffs
  },
  {
    path: "/tariff/:id",
    name: "tariff",
    component: Tariff
  },
  {
    path: "/management-settings",
    name: "Management Settings",
    component: ManagementSettings
  },
  {
    path: "/settings/:id",
    name: "settings",
    component: Settings
  },
  {
    path: "/document-designer/:type?",
    name: "documentdesigner",
    component: DocumentDesigner
  },
  {
    path: "/test",
    name: "test",
    component: ComponentTest
  },

  {
    path: "/report-wizard",
    name: "reportwizard",
    component: ReportWizard
  },
  {
    path: "/storage/:id?",
    name: "storage",
    component: Storage
  },
  {
    path: "/reports",
    name: "reports",
    component: Reports
  },
  {
    path: "/report/:id",
    name: "report",
    component: Report
  },
  {
    path: "/storage-detail/:id",
    name: "Storage Detail",
    component: StorageDetail
  },
  {
    path: "/customer-detail/:id",
    name: "Customer Detail",
    component: CustomerDetail
  },
  {
    path: "/import-table",
    name: "Import From eMover",
    component: ImportTable
  },
  {
    path: "/settings-menu",
    name: "Settings Menu",
    component: SettingsMenu
  },
  {
    path: "/admin/portal",
    name: "Admin",
    component: Portal
  },
  {
    path: "/admin/users",
    name: "Admin",
    component: Users
  },
  {
    path: "/admin/roles",
    name: "Admin",
    component: Roles
  },
  {
    path: "/admin/permissions",
    name: "Admin",
    component: Permissions
  },
  {
    path: "/CustomerDocument/:id",
    name: "CustomerDocument",
    component: CustomerDocument
  },
  {
    path: "/c/:encrypted",
    name: "charge",
    component: CreditCard
  },
  {
    path: "/charge-card/:id?",
    name: "chargeCard",
    component: StripeForm
  },
  {
    path: "/lead-access/:token",
    name: "LeadAccess",
    component: LeadAccess
    // props: true
  }
  // {
  //   path: "*",
  //   name: "404",
  //   component: NotFound
  // }
];
